import ActivatedInfo from './ActivatedInfo';
/**
 *
 *
 * @export
 * @class ActivatedMaker
 */
export default class ActivatedMaker {
  constructor(cidMaker) {
    this.list = [];
    this.cidMaker = cidMaker;
  }

  make(data) {
    if (!data || data.length === 0) {
      return [];
    }

    let result = [];
    data.forEach(cue => {
      let temp = cue.content2;
      if (!temp) {
        temp = cue.content;
      }

      let content;
      if (typeof temp === 'string') {
        content = JSON.parse(temp);
      } else {
        content = temp;
      }

      // 去除已删除的容器操作
      if (!this.cidMaker.map.has(content['cid'])) {
        return;
      }

      let commands = content.command;
      if (commands) {
        commands.forEach(command => {
          if (command['type'] === 'active') {
            let info = new ActivatedInfo();
            info.cid = content['cid'];
            info.uniqueID = content['uniqueID'];
            info.activatedTime = cue['created_at'];
            result.push(info);
          }
          if (command['event'] === 'onSlideChange') {
            let index = result.findIndex(item => item.cid === content['cid']);
            if (index < 0) {
              let info = new ActivatedInfo();
              info.cid = content['cid'];
              info.uniqueID = content['uniqueID'];
              info.activatedTime = cue['created_at'];
              result.push(info);
            }
          }
        });
      }
    });
    return result;
  }
}
